import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { Typography, useTheme } from "@mui/material";

const Bullet = () => {
  const theme = useTheme();
  return (
    <RadioButtonCheckedIcon
      sx={{
        position: "absolute",
        left: 0,
        top: "0.15rem",
        scale: 0.85,
        color: theme.slidePalette.brightGreen,
      }}
      style={{ fontSize: "inherit" }}
    />
  );
};

const SlideBullets = ({ value }) => {
  const values = (value || "").split("\n").filter(Boolean);
  if (values.length === 0) {
    return null;
  }
  return (
    <ul style={{ listStyleType: "none", padding: "0", margin: "0" }}>
      {values.map((item, index) => (
        <li
          key={index}
          style={{
            marginBottom: "0",
            display: "flex",
            alignItems: "top",
            position: "relative",
          }}
        >
          <Typography variant="body2" pl={2.5} sx={{ textAlign: "justify" }}>
            <Bullet />
            {item}
          </Typography>
        </li>
      ))}
    </ul>
  );
};

export default SlideBullets;
